<template>
  <v-app class="d-print-none">
    <v-main class="d-print-none">
      <router-view/>
    </v-main>
  </v-app>
</template>

<script>

export default {
  name: 'App',

  data: () => ({
    //
  }),
};
</script>
